import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a981451"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-center" }
const _hoisted_2 = { class: "gutter-s6" }
const _hoisted_3 = { class: "flex align-items-center mb-s2" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { class: "flex align-items-center flex-wrap md:flex-nowrap gutter-s2" }
const _hoisted_6 = { class: "flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray" }, " %", -1))
const _hoisted_8 = {
  key: 0,
  class: "flex text-info mt-s2"
}
const _hoisted_9 = { class: "text-sm transaction-warning" }
const _hoisted_10 = {
  key: 1,
  class: "flex text-info mt-s2"
}
const _hoisted_11 = { class: "text-sm transaction-warning" }
const _hoisted_12 = { class: "flex align-items-center mb-s2" }
const _hoisted_13 = { class: "text-muted" }
const _hoisted_14 = { class: "flex align-items-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-s2 text-muted" }, "min", -1))
const _hoisted_16 = { class: "flex align-items-center mt-s5 w-14rem" }
const _hoisted_17 = { class: "text-muted ml-s5" }
const _hoisted_18 = {
  key: 0,
  class: "flex align-items-center mt-s3 w-16rem gutter-x-s3"
}
const _hoisted_19 = { class: "text-muted" }
const _hoisted_20 = { class: "dialog-footer dialog-footer-two-btn" }

import { computed, ref } from 'vue';
import FormattedInput from '@/components/FormattedInput.vue';
import Icon from '@/components/icon/Icon.vue';
import validateTransactionSettingsMixin from '@/mixins/validate-transaction-settings.mixin';
import { compareObjects } from '@/utils/object';
import {
  MIN_NORMAL_SLIPPAGE_TOLERANCE_PERCENT,
  MAX_NORMAL_SLIPPAGE_TOLERANCE_PERCENT,
} from '@/constants/transactionSettings';
import Switch from '@/components/switch/Switch.vue';
import { ENABLE_CROSS_CHAIN } from '@/helpers/crossChainEnv.helper';
import { useI18n } from 'vue-i18n';
import { useSwap } from '@/store/modules/swap/useSwap';
import TooltipIcon from '@/components/tooltip/TooltipIcon.vue';
import { ITransactionSetting } from '@/store/modules/swap/models/transaction-setting.interface';


export default /*#__PURE__*/_defineComponent({
  __name: 'SwapSetting',
  setup(__props) {

const { validateTransactionDeadline, validateSlippageTolerance } =
  validateTransactionSettingsMixin.methods;
const { t } = useI18n();
const { swapSettings, setSettings } = useSwap();

const isShowDialog = ref(false);
const settings = ref<ITransactionSetting>(Object.assign({}, swapSettings));
const toleranceValues = [0.1, 0.5, 1, 2, 3];
const isDisableApplyButton = computed(() => compareObjects(settings.value, swapSettings));

const onDialogOpen = () => {
  isShowDialog.value = true;
};
const onDialogClose = () => {
  isShowDialog.value = false;
};
const formatValue = value => {
  return value.toFixed(1) + '%';
};
const setSlippageTolerance = value => {
  settings.value.slippageTolerance = value.toString();
};
const onApplySetting = () => {
  setSettings(settings.value);
  onDialogClose();
};

const onChangeTransactionDeadlineInput = () => {
  settings.value.transactionDeadline = validateTransactionDeadline(
    settings.value.transactionDeadline,
  );
};
const onChangeSlippageTolerance = () => {
  settings.value.slippageTolerance = validateSlippageTolerance(settings.value.slippageTolerance);
};

const isSlippageToleranceTooLow = computed(
  () => +settings.value.slippageTolerance < MIN_NORMAL_SLIPPAGE_TOLERANCE_PERCENT,
);
const isSlippageToleranceTooHigh = computed(
  () => +settings.value.slippageTolerance > MAX_NORMAL_SLIPPAGE_TOLERANCE_PERCENT,
);
const enableCrossChain = computed(() => ENABLE_CROSS_CHAIN);
const restoreSettings = () => {
  settings.value = Object.assign({}, swapSettings);
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Icon, {
      name: "setting",
      size: "24",
      onClick: onDialogOpen,
      class: "icon-setting"
    }),
    _createVNode(_component_Dialog, {
      visible: isShowDialog.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((isShowDialog).value = $event)),
      header: _ctx.$t('swap.settingDialog.header'),
      modal: true,
      dismissableMask: "",
      class: "dialog-setting",
      onHide: restoreSettings
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('swap.settingDialog.slippageTolerance.caption')), 1),
              _createVNode(TooltipIcon, {
                tooltip: _unref(t)('swap.settingDialog.slippageTolerance.tooltip')
              }, null, 8, ["tooltip"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(toleranceValues, (value) => {
                return _createElementVNode("div", { key: value }, [
                  _createVNode(_component_Button, {
                    label: formatValue(value),
                    class: _normalizeClass(["button-rounded button-base", { active: +settings.value.slippageTolerance === value }]),
                    onClick: ($event: any) => (setSlippageTolerance(value))
                  }, null, 8, ["label", "class", "onClick"])
                ])
              }), 64)),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(FormattedInput, {
                  modelValue: settings.value.slippageTolerance,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((settings.value.slippageTolerance) = $event)),
                  class: "input-panel w-4rem mr-1 text-center",
                  onChange: onChangeSlippageTolerance
                }, null, 8, ["modelValue"]),
                _hoisted_7
              ])
            ]),
            (_unref(isSlippageToleranceTooLow))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(Icon, {
                    name: "infoStar",
                    size: "20",
                    class: "mr-1"
                  }),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('swap.settingDialog.infoMessage.transactionMayFail')), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(isSlippageToleranceTooHigh))
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(Icon, {
                    name: "infoStar",
                    size: "20",
                    class: "mr-1"
                  }),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('swap.settingDialog.infoMessage.transactionMayBeFrontrun')), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('swap.settingDialog.transactionDeadline.caption')), 1),
              _createVNode(TooltipIcon, {
                tooltip: _unref(t)('swap.settingDialog.transactionDeadline.tooltip')
              }, null, 8, ["tooltip"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(FormattedInput, {
                modelValue: settings.value.transactionDeadline,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((settings.value.transactionDeadline) = $event)),
                class: "input-panel w-4rem text-center",
                onChange: onChangeTransactionDeadlineInput
              }, null, 8, ["modelValue"]),
              _hoisted_15
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(Switch, {
                modelValue: settings.value.enableMultiHops,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((settings.value.enableMultiHops) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_17, [
                _createTextVNode(_toDisplayString(_unref(t)('swap.settingDialog.allowMultihops.caption')) + " ", 1),
                _createVNode(TooltipIcon, {
                  tooltip: _unref(t)('swap.settingDialog.allowMultihops.tooltip'),
                  inline: ""
                }, null, 8, ["tooltip"])
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            (_unref(enableCrossChain))
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(Switch, {
                    modelValue: settings.value.localSwapPriority,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((settings.value.localSwapPriority) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_19, [
                    _createTextVNode(_toDisplayString(_unref(t)('swap.settingDialog.localSwapPriority.caption')) + " ", 1),
                    _createVNode(TooltipIcon, {
                      tooltip: _unref(t)('swap.settingDialog.localSwapPriority.tooltip'),
                      inline: ""
                    }, null, 8, ["tooltip"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_Button, {
            class: "button-base",
            label: _unref(t)('cancel'),
            onClick: onDialogClose
          }, null, 8, ["label"]),
          _createVNode(_component_Button, {
            class: "button-primary",
            disabled: _unref(isDisableApplyButton),
            label: _unref(t)('swap.settingDialog.applyBtn'),
            onClick: onApplySetting
          }, null, 8, ["disabled", "label"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ]))
}
}

})